import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-startups-list',
  templateUrl: './startups-list.component.html',
  styleUrls: ['./startups-list.component.scss']
})
export class StartupsListComponent implements OnInit {

  startups;
  constructor(private afs: AngularFirestore) { }

  ngOnInit(): void {
    this.afs.collection('startups').valueChanges().pipe(
      map(arr => {
        return arr.sort((a: any, b: any) => {
          if (a.votes < b.votes)
            return -1
          if (a.votes > b.votes)
          return 1
          return 0
        })
      })
    ).subscribe((data) => {
      this.startups = data
    })
  }

}
